import React from "react";
import * as CompareSpecsStyles from "../styles/CompareSpecs";
import IconArrowDown from "../../../../../common-deprecated/svg/lexus/arrow-down.svg";
import useItemDescription from "../../../../../shared-logic/features/compare/hooks/useItemDescription";
import { CompareV2Label } from "../../../utils/labels";
import { ToggleIconWrapper } from "../../../../../common-deprecated/styles/lexus/IconWrapper";

export type CompareDescriptionType = {
    description?: string;
    isPdf?: boolean;
    heightLimit: number;
};
const ItemDescription = ({ isPdf, description, heightLimit }: CompareDescriptionType): JSX.Element | null => {
    const { height, contentRef, open, setOpen } = useItemDescription(isPdf);

    return description ? (
        <>
            <CompareSpecsStyles.Description
                heightLimit={heightLimit}
                fullHeight={height}
                showReadMore={isPdf ? false : height > heightLimit}
                open={open}
                ref={contentRef}
            >
                <span dangerouslySetInnerHTML={{ __html: description }} />
            </CompareSpecsStyles.Description>
            {height > heightLimit && !isPdf && (
                <CompareSpecsStyles.ReadMoreLess onClick={() => setOpen(!open)}>
                    {open ? (
                        <CompareV2Label label="T1.readLess" fallbackLabel="readLess" />
                    ) : (
                        <CompareV2Label label="T1.readMore" fallbackLabel="readMore" />
                    )}
                    <ToggleIconWrapper isDown={!open}>
                        <IconArrowDown />
                    </ToggleIconWrapper>
                </CompareSpecsStyles.ReadMoreLess>
            )}
        </>
    ) : null;
};

export default ItemDescription;
